








import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({
  name: 'Intersection',
})
export default class FormatServices extends Vue {
  @Ref('intersectionComponent') intersectionComponent!: any;
  shownComponent = false

  intersection(component: any) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          this.shownComponent = true;
          io.unobserve(entry.target);
        }
      });
    });

    io.observe(this.intersectionComponent);
  }

  async mounted() {
    await this.$nextTick()
    this.intersection(this.intersectionComponent)
  }
}
